import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { ProfileSelectorComponent as ProfileSelectorUIComponent } from '@com-delta-idp/mnx-capability-profile-selector-ui';
import {
  DeviceTypeService,
  FlyoutPositionDirective
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { HeightCalculationUtils } from '../data-access/utils/height-calculation-utils';
import { TabNavigationUtils } from '../data-access/utils/tab-navigation-utils';
import { ProfileSelectorSupportComponent } from './profile-selector-support.component';
@Component({
  selector: 'idp-profile-selector',
  standalone: true,
  templateUrl: './profile-selector.component.html',
  styleUrls: ['./profile-selector.component.scss'],
  imports: [CommonModule, ProfileSelectorUIComponent, FlyoutPositionDirective]
})
export class ProfileSelectorComponent
  extends ProfileSelectorSupportComponent
  implements AfterViewInit
{
  @Input() enableMachCoreProfileSelector = false;
  @Output() toggle = new EventEmitter<boolean>();
  @Output() showSwitching = new EventEmitter<boolean>();
  @ViewChild('loginPickerRedirectForm')
  loginPickerRedirectForm!: ElementRef<HTMLFormElement>;

  @ViewChild('flyoutProfileSelectorDesktop')
  flyoutProfileSelectorDesktop!: ElementRef;

  @ViewChild('flyoutProfileSelectorMobile')
  flyoutProfileSelectorMobile!: ElementRef;

  @ViewChild('profileModal', { static: false }) profileModal!: ElementRef;
  @ViewChild(ProfileSelectorUIComponent) child!: ProfileSelectorUIComponent;

  private deviceTypeService = inject(DeviceTypeService);
  show = false;
  isDesktop = true;

  ngAfterViewInit(): void {
    this.isDesktop = this.deviceTypeService.getDeviceType().isDesktop;

    if (this.enableMachCoreProfileSelector) {
      this.show = true;
      setTimeout(() => {
        this.machCoreModalUtilService.openModal(
          this.isDesktop,
          this.flyoutProfileSelectorDesktop,
          this.flyoutProfileSelectorMobile
        );
      });
      this.getDataForStandAlonePage();
    } else {
      this.modalContainerFocus();
      this.getElementRef();
      this.setModalProperties();
      this.getDataForStandAlonePage();
    }
  }

  getElementRef(): void {
    this.getElementRefHelper(this.loginPickerRedirectForm);
  }

  setModalProperties(): void {
    this.setupModalProperties();
    this.setModalPosition();
  }

  getDataForStandAlonePage(): void {
    this.initializeDataForStandAlonePage(
      this.enableMachCoreProfileSelector,
      this.setModalProperties.bind(this)
    );
  }

  @HostListener('window:resize')
  onResize(): void {
    this.handleResize();
  }

  @HostListener('document:keydown', ['$event'])
  handleTabKeyWInModel(event: KeyboardEvent): void {
    if (this.fromStandAlonePage || event.key !== 'Tab') return;
    this.handleTabNavigation(event);
  }

  onClose(): void {
    this.toggle.emit();
    this.renderer.removeClass(document.body, 'modal-open');
  }

  setModalPosition(): void {
    if (!this.enableMachCoreProfileSelector) {
      if (this.profileModal?.nativeElement) {
        const totalHeight = HeightCalculationUtils.calculateTotalHeight();
        const top = HeightCalculationUtils.getModalTop(
          totalHeight,
          this.innerWidth
        );
        this.renderer.setStyle(this.profileModal.nativeElement, 'top', top);
        this.setStyleForStandalone(
          this.profileModal.nativeElement,
          totalHeight
        );
      }
    }
  }

  private handleResize(): void {
    this.isDesktop = this.deviceTypeService.getDeviceType().isDesktop;
    this.handleResizeOperations();
    this.setModalPosition();
    if (this.enableMachCoreProfileSelector) {
      this.handleModalResize();
    }
  }

  private handleModalResize(): void {
    this.machCoreModalUtilService.handleModalResize(
      this.show,
      this.isDesktop,
      this.flyoutProfileSelectorDesktop,
      this.flyoutProfileSelectorMobile
    );
  }

  private handleTabNavigation(event: KeyboardEvent): void {
    TabNavigationUtils.handleTabNavigation(
      event,
      this.elementRef,
      this.focusTab.bind(this)
    );
  }
}
